import type { DataTableAction } from "@circleco/compass/components/DataTable";
import { useMemo } from "react";

import { t } from "@/i18n-js/instance";

import type { RawSpaceGroupMember } from "../helpers";

export const useSpaceGroupMembersTabRowActions = ({
  isAdmin,
  onEditMember,
  onRemoveMember,
}: {
  isAdmin: boolean;
  onEditMember: (member: RawSpaceGroupMember) => void;
  onRemoveMember: (memberId: string) => void;
}) =>
  useMemo<DataTableAction<RawSpaceGroupMember>[]>(
    () => [
      {
        icon: "pencil",
        get label() {
          return t("spaces.form.edit.members.edit_member");
        },
        showInMenu: true,
        hidden: () => !isAdmin,
        onClick: row => onEditMember(row),
      },
      ...(isAdmin ? (["divider"] as const) : []),
      {
        icon: "trash-can",
        get label() {
          return t([
            "space_groups.form.edit.members",
            "remove_from_space_group",
          ]);
        },
        showInMenu: true,
        danger: true,
        hidden: () => !isAdmin,
        onClick: row => onRemoveMember(String(row.id)),
      },
    ],
    [isAdmin, onEditMember, onRemoveMember],
  );
